module.exports = __webpack_public_path__ + "img/hondapassport.b42e9cdf.png";